import { ErrorHandler, inject, Injectable } from '@angular/core'
import * as Sentry from '@sentry/browser'
import HttpError from '@ui/HttpError'
import { PermissionsService } from '@client/Services/PermissionsService'
import User from '@client/User'

@Injectable()
export default class AppErrorHandler implements ErrorHandler {
	private readonly permissionService: PermissionsService

	constructor() {
		this.permissionService = inject(PermissionsService)
	}

	public handleError(error: any): void {
		if (!(error instanceof HttpError)) {
			if (process.env.NODE_ENV === 'production') {
				if (this.permissionService.user instanceof User) {
					this.setUserContext()
				}
				Sentry.captureException(error.originalError || error)
			} else {
				console.error(error)
			}
		}
	}

	private readonly setUserContext = (): void => {
		if (this.permissionService.user) {
			Sentry.setUser({
				email: this.permissionService.user.email,
				id: this.permissionService.user.id.toString(),
				name: `${this.permissionService.user.name}`,
				scope: 'client',
			})
		}
	}
}
